import { BRAND } from "../../lib/data";
import { Mail, Phone, MapPin, Facebook, Lock } from "lucide-react";

export const Footer = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="site-footer" className="bg-charcoal text-sand relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-24 pb-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3">
              <img src={BRAND.logo} alt={BRAND.name} className="h-12 w-12 rounded-full object-cover" />
              <div>
                <p className="font-heading text-2xl">{BRAND.name}</p>
                <p className="text-[10px] uppercase tracking-[0.25em] text-clay">{BRAND.tagline}</p>
              </div>
            </div>
            <p className="mt-5 text-sand/60 font-light max-w-xs leading-relaxed">
              Mobile equine sports massage therapy, helping horses move freely and feel their best, at your own barn.
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-clay">Explore</p>
            <ul className="mt-5 space-y-3">
              {[
                ["About", "about"],
                ["My Story", "story"],
                ["What I do", "services"],
                ["Process", "process"],
                ["Pricing", "pricing"],
                ["Reviews", "reviews"],
                ["FAQ", "faq"],
                ["Book a session", "book"],
              ].map(([l, id]) => (
                <li key={id}>
                  <button data-testid={`footer-link-${id}`} onClick={() => go(id)} className="text-sand/70 hover:text-sand transition-colors">
                    {l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-clay">Get in touch</p>
            <ul className="mt-5 space-y-4 text-sand/70 font-light">
              <li className="flex items-center gap-3"><Mail size={18} strokeWidth={1.5} className="text-clay" /> strideandstone@gmail.com</li>
              <li className="flex items-center gap-3"><Phone size={18} strokeWidth={1.5} className="text-clay" /> Available on request</li>
              <li className="flex items-center gap-3"><MapPin size={18} strokeWidth={1.5} className="text-clay" /> Serving Fredericksburg, Spotsylvania &amp; Stafford, VA</li>
              <li>
                <a
                  href="https://www.facebook.com/share/14dqaTA8mKt/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-facebook"
                  className="flex items-center gap-3 hover:text-sand transition-colors"
                >
                  <Facebook size={18} strokeWidth={1.5} className="text-clay" /> Stride &amp; Stone Equine
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-sand/10 flex flex-col md:flex-row justify-between gap-4 text-sm text-sand/40">
          <p>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <p>Qualified Equine Sports Massage Therapist</p>
            <a
              href="/admin/login"
              data-testid="footer-admin-link"
              className="inline-flex items-center gap-1.5 text-sand/50 hover:text-clay transition-colors"
            >
              <Lock size={13} strokeWidth={1.5} /> Admin
            </a>
          </div>
        </div>
      </div>
      <p className="select-none pointer-events-none font-heading text-[15vw] leading-none text-sand/[0.04] text-center -mb-4 md:-mb-10">
        Stride &amp; Stone
      </p>
    </footer>
  );
};
